"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxBigNumberForTransaction = exports.minBigNumber = exports.maxBigNumber = exports.babylonianSqrt = void 0;
const babylonianSqrt = (y) => {
    let z = 0n;
    if (y > 3n) {
        z = y;
        let x = y / 2n + 1n;
        while (x < z) {
            z = x;
            x = (y / x + x) / 2n;
        }
    }
    else if (y > 0) {
        z = 1n;
    }
    return z;
};
exports.babylonianSqrt = babylonianSqrt;
const maxBigNumber = (b1, b2) => {
    return b1 > b2 ? b1 : b2;
};
exports.maxBigNumber = maxBigNumber;
const minBigNumber = (b1, b2) => {
    return b1 < b2 ? b1 : b2;
};
exports.minBigNumber = minBigNumber;
const maxBigNumberForTransaction = () => {
    return 2n ** 256n - 1n;
};
exports.maxBigNumberForTransaction = maxBigNumberForTransaction;
